import { z } from 'zod';
import {
  IdSchema,
  JsonValueSchema,
  NonEmptyStringSchema,
  TimestampSchema,
} from './common';
import { FunnelOverviewArtifactResponseSchema } from './funnel-overview';

const JsonValueArraySchema = z.array(JsonValueSchema).readonly();

export const FunnelSwipeStatusSchema = z.enum([
  'generating',
  'ready',
  'failed',
  'applied',
]);

export const FunnelSwipeSourceCaptureSchema = z.object({
  run_id: IdSchema,
  source_url: NonEmptyStringSchema,
  captured_at: TimestampSchema,
  max_pages: z.number().int().positive().optional(),
});

export const FunnelSwipeMatchSchema = z.object({
  proposal_hash: IdSchema.optional(),
  slots: JsonValueArraySchema.optional(),
  gaps: JsonValueArraySchema.optional(),
});

export const FunnelSwipeReproductionSchema = z.object({
  build_id: IdSchema.optional(),
  status: NonEmptyStringSchema.optional(),
  output_dir: NonEmptyStringSchema.optional(),
  stream_url: NonEmptyStringSchema.optional(),
  gaps: JsonValueArraySchema.optional(),
});

export const FunnelSwipeSchema = z.object({
  id: IdSchema,
  type: z.literal('funnel'),
  title: NonEmptyStringSchema,
  status: FunnelSwipeStatusSchema,
  source_capture: FunnelSwipeSourceCaptureSchema,
  result: FunnelOverviewArtifactResponseSchema,
  match: FunnelSwipeMatchSchema.optional(),
  reproduction: FunnelSwipeReproductionSchema.optional(),
  gaps: JsonValueArraySchema.optional(),
  created_at: TimestampSchema,
  updated_at: TimestampSchema,
});

export type FunnelSwipeStatus = z.infer<typeof FunnelSwipeStatusSchema>;
export type FunnelSwipeSourceCapture = z.infer<
  typeof FunnelSwipeSourceCaptureSchema
>;
export type FunnelSwipeMatch = z.infer<typeof FunnelSwipeMatchSchema>;
export type FunnelSwipeReproduction = z.infer<
  typeof FunnelSwipeReproductionSchema
>;
export type FunnelSwipe = z.infer<typeof FunnelSwipeSchema>;
